import { render, staticRenderFns } from "./PhotoStore.vue?vue&type=template&id=74950e97"
import script from "./PhotoStore.vue?vue&type=script&lang=js"
export * from "./PhotoStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports